<template>
  <div class="user">
    <div class="photo">
      <img :src="profilePhoto" />
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.prevent="toggleMenu" href="">
         <span>
           {{ usersName }}
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#/profile">
                <span class="sidebar-mini-icon"><i class="ti-user"></i></span>
                <span class="sidebar-normal">My Profile</span>
              </a>
            </li>
            <li>
              <a href="#/profile/password">
                <span class="sidebar-mini-icon"><i class="ti-key"></i></span>
                <span class="sidebar-normal">Change Password</span>
              </a>
            </li>
            <li>
              <a href="#/logout">
                <span class="sidebar-mini-icon"><i class="ti-direction"></i></span>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'
  import user from 'src/user'

  export default {
    components: {
      CollapseTransition
    },
    data() {
      return {
        isClosed: true,
        usersName: null,
        profilePhoto: null
      }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },

      getUsersName () {
        user.profile(this.$http, userData => {
          if(userData) {
            this.usersName = user.firstName + ' ' + user.lastName

            if (user.profilePhoto) {
              this.profilePhoto = process.env.VUE_APP_PHOTO_DIR_PUBLIC + user.profilePhoto
            }else{
              this.profilePhoto = 'static/img/face-0.jpg'
            }
          }
        })
      }
    },

    async mounted () {
      this.getUsersName ()
    },
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
